// @flow
import React from "react";
import { connect, Dispatch } from "react-redux";
import {
    type SearchRequestDTO,
    type SearchCountResultDTO,
    SearchRequestType,
    type SearchFilterDTO,
    type SearchNodeTypeEnum,
    type SearchScopeEnum,
} from "data/types";
import debounce from "lodash/debounce";
import loc from "i18next";
import { userLanguage } from "data/storeHelper";
import {
    getSearchCountAction /*, togglesUpdateCounterAction*/,
} from "data/actions";
import * as s from "data/reducers/selectors";
import Constants, { type ConstantsEnum } from "data/constants";
import Status from "components/Status";

type Props = {
    /** Redux dispatch */
    dispatch: Dispatch,
    /** CSS class name to apply */
    className?: string,
    /** initial input text */
    searchText: string,
    /** any specific filters */
    filters: Array<SearchFilterDTO>,
    /** initial search scope */
    searchScope: SearchScopeEnum,
    /** initial search scope itemUri */
    itemUri: string,
    /** search nodeType */
    nodeType: SearchNodeTypeEnum,
    /** redux: search result counts */
    count: ?SearchCountResultDTO,
    /** redux count/aggregations fetch status */
    status: ConstantsEnum,
};

export class TotalCounts extends React.Component<Props, State> {
    componentDidMount = () => this.getSearchResultCount();

    componentDidUpdate(prevProps: Props) {
        /* istanbul ignore else */
        if (
            this.props.searchText !== prevProps.searchText ||
            this.props.filters !== prevProps.filters ||
            this.props.searchScope !== prevProps.searchScope ||
            this.props.itemUri !== prevProps.itemUri ||
            this.props.nodeType !== prevProps.nodeType
        ) {
            this.getSearchResultCount();
        }
        // /* istanbul ignore else */
        // if (this.props.count !== prevProps.count) {
        //     this.props.dispatch(
        //         togglesUpdateCounterAction({
        //             name: "search",
        //             counts: {
        //                 search: this.props.count && this.props.count.totalCount
        //             },
        //             status: { search: this.props.status }
        //         })
        //     );
        // }
    }

    _getSearchResultCount = (): Promise => {
        const searchRequest: SearchRequestDTO = {
            id: -1,
            searchType: SearchRequestType.Freetext,
            scope: this.props.searchScope,
            searchText: this.props.searchText,
            itemUri: this.props.itemUri,
            filters: this.props.filters,
            nodeType: this.props.nodeType,
            sorts: [],
        };
        this.props.dispatch(getSearchCountAction({ searchRequest }));
    };

    getSearchResultCount = debounce(this._getSearchResultCount, 300, {
        leading: true,
        trailing: true,
        maxWait: 700,
    });

    render() {
        if (
            this.props.status === Constants.LOADING ||
            this.props.status === Constants.ERROR
        )
            return (
                <div className={this.props.className}>
                    {" "}
                    <Status inline status={this.props.status} />
                </div>
            );
        else if (
            this.props.count.totalCount === -1 ||
            this.props.count.totalTime === -1
        )
            return null;
        else
            return (
                <div className={this.props.className}>
                    {loc.t("search:stats.totalCount", {
                        count: this.props.count.totalCount,
                    })}
                    <span className="totalTime">
                        {loc.t("search:stats.totalTime", {
                            totalTime: (
                                this.props.count.totalTime / 1000
                            ).toLocaleString(userLanguage(), {
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 2,
                            }),
                        })}
                    </span>
                </div>
            );
    }
}

// apply Redux Store state to Component Properties
const mapStateToProps = /* istanbul ignore next */ (state, ownProps) => ({
    status: s.searchCountStatusSelector(state),
    count: s.searchCountResultSelector(state),
    ...ownProps,
});

export default connect(mapStateToProps)(TotalCounts);
